import * as React from "react";
import {Dispatch} from "redux";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {RootState} from "../../../store/reducer/root/RootState";
import {Option} from "ts-option";
import {connect} from "react-redux";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import Toast from "../../helper/Toast";
import SidebarConfig from "./SidebarConfig";
import {updateLeadSidebarOrder} from "../../../store/action/sidebar/sidebar";

interface IDispatchProps {
	/**
	 * Update lead sidebar order
	 * @param {string[]} sidebarOrder
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateLeadSidebarOrder: (sidebarOrder: string[], onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface ReduxProps {
	/**
	 * Lead sidebar order.
	 */
	leadSidebarOrder: Option<string[]>;
}

type Props = IDispatchProps & ReduxProps;

class LeadSidebarConfig extends React.Component<Props> {
	sidebarMap: { [key in LeadSidebarItem]: string } = {
		BRAND: "Brand",
		PARTNER_BRAND: "Partner brand",
		SITE_ADDRESS: "Site address",
		CUSTOMER: "Customer",
		MERCHANT_BRANCH_LOCATION: "Merchant branch location",
		TAGS: "Tags",
		DESCRIPTION: "Description",
		LEAD_TYPE: "Lead type",
		WATCHERS: "Watchers",
		HOW_PROSPECT_FOUND_US: "How prospect found us",
		REASON_FOR_CONTACT: "Reason for contact",
		INBOUND_MARKETING_AND_TRACKING: "Inbound marketing and tracking",
		CUSTOM_FIELDS: "Custom fields",
		// UNUSED
		PAY_BY_FINANCE: "Pay by finance"
	};

	render() {
		return (
			<SidebarConfig updateSidebarOrder={this.updateSidebarOrder}
						   pageTitle={'Lead sidebar order'}
						   sidebarOrder={this.props.leadSidebarOrder}
						   sidebarMap={this.sidebarMap}/>
		);
	}

	updateSidebarOrder = (sidebarOrder: string[], onSuccess: OnSuccess, onFailure: OnFailure) =>
		this.props.updateLeadSidebarOrder(sidebarOrder,
			() => {
				onSuccess();
				Toast.success("Lead sidebar order updated", "Lead sidebar order update");
			},
			(err) => {
				onFailure(err);
				notifyBugsnagAndShowToast(err, "Lead sidebar order update failed");
			}
		);
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateLeadSidebarOrder: (sidebarOrder: string[], onSuccess: OnSuccess, onFailure: OnFailure) => {
			dispatch(updateLeadSidebarOrder(sidebarOrder, onSuccess, onFailure))
		}
	};
}

function mapStateToProps(state: RootState) {
	return {
		leadSidebarOrder: state.sidebarOrder.leadSidebarOrder
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadSidebarConfig)

export enum LeadSidebarItem {
	BRAND = "BRAND",
	PARTNER_BRAND = "PARTNER_BRAND",
	CUSTOMER = "CUSTOMER",
	SITE_ADDRESS = "SITE_ADDRESS",
	DESCRIPTION = "DESCRIPTION",
	MERCHANT_BRANCH_LOCATION = "MERCHANT_BRANCH_LOCATION",
	TAGS = "TAGS",
	WATCHERS = "WATCHERS",
	LEAD_TYPE = "LEAD_TYPE",
	REASON_FOR_CONTACT = "REASON_FOR_CONTACT",
	HOW_PROSPECT_FOUND_US = "HOW_PROSPECT_FOUND_US",
	INBOUND_MARKETING_AND_TRACKING = "INBOUND_MARKETING_AND_TRACKING",
	CUSTOM_FIELDS = "CUSTOM_FIELDS",
	// UNUSED
	PAY_BY_FINANCE= "PAY_BY_FINANCE"
}